<template>
    <form @submit.prevent="onContactoForm">
        <b-alert v-model="ifSuccess" variant="success" dismissible>
            ¡El mensaje se envió correctamente!
        </b-alert>
        <div class="form-group">
            <label class="control-label" for="fullname">Nombre <span>*</span></label>
            <input
                v-model.trim="$v.form.nombre.$model"
                :class="{ 'is-invalid': $v.form.nombre.$error }"
                type="text"
                class="form-control white_bg"
                id="fullname"
                name="fullname"
            />
            <div class="invalid-feedback">
                <span v-if="!$v.form.nombre.$required"
                    >Este campo es requerido</span
                >
            </div>
        </div>
        <div class="form-group">
            <label class="control-label" for="email">Correo <span>*</span></label>
            <input
                v-model.trim="$v.form.email.$model"
                :class="{ 'is-invalid': $v.form.email.$error }"
                type="email"
                name="email"
                class="form-control white_bg"
                id="email"
            />
            <div class="invalid-feedback">
                <span v-if="!$v.form.email.$required"
                    >Este campo es requerido</span
                >
                <br />
                <span v-if="!$v.form.email.$email"
                    >Formato de correo electrónico inválido</span
                >
            </div>
        </div>
        <div class="form-group">
            <label class="control-label" for="phone">Celular <span>*</span></label>
            <input
                v-model.number.lazy="$v.form.celular.$model"
                :class="{ 'is-invalid': $v.form.celular.$error }"
                type="text"
                maxlength="10"
                name="phone"
                class="form-control white_bg"
                id="phone"
            />
            <div class="invalid-feedback">
                <span v-if="!$v.form.celular.$required"
                    >Este campo es requerido</span
                >
                <br />
                <span v-if="!$v.form.celular.$numeric"
                    >Formato de teléfono inválido</span
                >
            </div>
        </div>
        <div class="form-group">
            <label class="control-label">Mensaje <span>*</span></label>
            <textarea
                v-model.trim="$v.form.mensaje.$model"
                :class="{ 'is-invalid': $v.form.mensaje.$error }"
                class="form-control white_bg"
                rows="4"
            ></textarea>
            <div class="invalid-feedback">
                <span v-if="!$v.form.mensaje.$required"
                    >Este campo es requerido</span
                >
            </div>
        </div>
        <div class="form-group">
            <label>
                <i class="fa fa-check-square" aria-hidden="true"></i>
                Al enviar tu mensaje estás aceptando nuestra
                <a
                    href="https://redautos.com/politica_tratamiento_datos_personales"
                    target="_blank"
                >
                    Política de privacidad de datos personales
                </a>
            </label>
        </div>
        <div class="form-group">
            <button :disabled="onLoadForm" class="btn" type="submit">
                Enviar mensaje
                <clip-loader
                    :class="{ 'd-none': !onLoadForm }"
                    style="display: inline;margin-right: 10px;"
                    color="#fff"
                    size="15px"
                ></clip-loader>
                <span :class="{ 'd-none': onLoadForm }" class="angle_arrow">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </button>
        </div>
    </form>
</template>

<script>
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            onLoadForm: false,
            ifSuccess: false,
            form: {
                email: "",
                nombre: "",
                celular: "",
                mensaje: ""
            }
        };
    },
    validations: {
        form: {
            nombre: { required },
            email: { required, email },
            celular: { required, numeric },
            mensaje: { required }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                email: "",
                nombre: "",
                celular: "",
                mensaje: ""
            };
        },
        onContactoForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return (this.submitStatus = "False");
            } else {
                this.onLoadForm = true;
                axios.post("/ajax/contact_form", this.form).then(response => {
                    var parseRes = response.data;
                    this.onLoadForm = false;
                    this.ifSuccess = true;
                    this.resetForm();
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
